module.exports = __webpack_public_path__ + "static/media/infiniti-thumbs.87588f2d.svg";